// Import Vue
import { createApp } from 'vue';
import store from '../store/store'
import { createI18n } from 'vue-i18n'
import messages from '@/locales/en'

import Toaster from '@meforma/vue-toaster';
import { createWebHistory, createRouter } from "vue-router";
//import {i18n} from './i18n'
/*import { defineRule } from 'vee-validate';
import { required, email, min } from '@vee-validate/rules';

defineRule('required', required);
defineRule('email', email);
defineRule('min', min);*/
// Import Framework7
import Framework7 from 'framework7/lite-bundle';

// Import Framework7-Vue Plugin
import Framework7Vue, { registerComponents } from 'framework7-vue/bundle';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

import '@/utils/jquery-global.js';

import VueNumerals from 'vue-numerals';
//import 'xlnt/dist/xlnt'
//window.load_xlnt = load_xlnt

// Import Framework7 Styles
import 'framework7/framework7-bundle.css';

// Import Icons and App Custom Styles
import "primeflex/primeflex.css";
import 'primevue/resources/themes/saga-blue/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'//icons

//import 'https://unpkg.com/leaflet-geosearch@2.6.0/assets/css/leaflet.css'

import '../css/icons.css';

import '../css/styles.css';
import '../css/helpers.scss';
import '../css/app.scss';
import '../fonts/fontastic/styles.css'

import "leaflet/dist/leaflet.css";                          
import "../leaflet/dist/css/leaflet.css";

import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('../leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('../leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('../leaflet/dist/images/marker-shadow.png')
});

// Import App Component
import App from '../components/app.vue';

// const Home = { template: '<div>Home</div>' }
// const routes = [
//   { path: '/', component: Home },
// ]
// const router = createRouter({
//   // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
//   history: createWebHistory(),
//   routes, // short for `routes: routes`
// })


// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Init App
const app = createApp(App);

const i18n = createI18n({
  /*locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',*/
  locale: 'en',
  fallbackLocale: 'en',

  messages: {'en': messages}
  //messages: {'en2': {}}
})

// Register Framework7 Vue components
registerComponents(app);

app.use(PrimeVue);
app.use(ConfirmationService);

app.use(store)
app.use(Toaster, {
  // One of the options
  position: 'bottom-right'
});
// with options
app.use(VueNumerals, {
  locale: 'en'
});
app.use(i18n)
app.use(ToastService);
//app.use(router)
/*app.use(i18n)*/




import { COM_TIMEFORMAT, COM_TIMEFORMAT2, COM_TIMEFORMAT3, COM_TIMEFORMAT4, COM_TIMEFORMAT5 } from './config.js';

app.config.globalProperties.$COM_TIMEFORMAT = COM_TIMEFORMAT;
app.config.globalProperties.$COM_TIMEFORMAT2 = COM_TIMEFORMAT2;
app.config.globalProperties.$COM_TIMEFORMAT3 = COM_TIMEFORMAT3;
app.config.globalProperties.$COM_TIMEFORMAT4 = COM_TIMEFORMAT4;
app.config.globalProperties.$COM_TIMEFORMAT5 = COM_TIMEFORMAT5;


// Mount the app
app.mount('#app');

$(window.document).on("click", function () {
  let msg = {
    type: "reset_checkOperationTimeOut",
    payload: {

    }
  }
  window.parent.postMessage(msg,"*")
  //console.log('reset timeout click')
});
